import AssetIdHoverCell from "./AssetIdHoverCell";
import VehicleCard from "./VehicleCard";

const VehicleIdHoverCell = ({ row, index, onClick, zIndex = 10000 }) => {
  return (
    <AssetIdHoverCell
      index={index}
      label={row?.vehicleId}
      onClick={onClick}
      defaultCardWidth={500}
      defaultCardHeight={430}
      zIndex={zIndex}
    >
      <VehicleCard row={row} />
    </AssetIdHoverCell>
  );
};

export default VehicleIdHoverCell;
